const minLength = (min:number) => (value:string) =>
  isNaN(value.length) || value.length >= min ? undefined : `Should be longer than ${min} characters.`


  export default minLength;